import React from 'react'
import AdminItem from './AdminItem'

const AdminContentPeople = ({ person, edit }) => {
  const personData = person.child('data')
  return (
    <AdminItem edit={edit} dbRef={personData.ref} param="people">
      <span className="admin-item-title">
        <strong>{personData.val().name}</strong>
      </span>
    </AdminItem>
  )
}

export default AdminContentPeople



// WEBPACK FOOTER //
// /opt/build/repo/src/components/admin/AdminContentPeople.js